import { Form } from "@circle-react-uikit/Form";

interface PostPurchaseSubjectInputTextProps {
  isDisabled: boolean;
}

export const PostPurchaseSubjectInputText = ({
  isDisabled,
}: PostPurchaseSubjectInputTextProps) => (
  <Form.Item
    className="!mt-0 !py-0"
    name="post_purchase_email_meta.subject"
    translationRoot="settings.paywalls.modal.tabs.post_purchase"
    fullWidth
    hideDescription
    hideBorder
    hidePlaceholder
  >
    <Form.Input disabled={isDisabled} />
  </Form.Item>
);
